module.exports = __webpack_public_path__ + "img/flag-de.75341718.svg";